// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__RlnRm","right":"Footer_right__erj1u","buttons":"Footer_buttons__12GMx"};